import {getBindingIndexFromBindingData} from "./common/get-binding-index-from-binding-data";
import {getEditableImages}              from "./common/get-editable-images";

export const getProductSurfacesWithImages = async ({productModel, ccHostResponse, productTags, ccConfig, proofImagesJpgs}) => {
    const items = getEditableImages({items: await productModel.getAllItems(), onlyVisibleOrderImages: true});
    return Array.from(productModel._surfaces).map((surface: any, i) => ({
        name: surface._name,
        width: surface._width,
        height: surface._height,
        // add items related to each surface to the surface data, and add thumbnail HTTP path
        items: items
            .filter(x => x.surfaceName === surface._name)
            .map((item) => {
                const image = item.image && {
                    ...item.image,

                    ...item.image?.ccStorageId && {
                        // add HTTP path to image if storage ID is available
                        httpPath: `${ccHostResponse?.ccHost}/api/ccviewer/img?f=${item.image.ccStorageId}&w=${item.image.width}&h=${item.image.height}`,
                        httpPathPrint: item.image.httpPath,
                        imageId: productTags?.imageSources?.find(x => x.surfaceName === item.surfaceName && x.variableName === item.name)?.assetId,
                    },
                };
                return ({
                    ...item,

                    // add additional data not known to the CC editor
                    bindingIndex: getBindingIndexFromBindingData(ccConfig.templateBindingData?.[item.surfaceName]?.[item.name]),
                    image,
                    // add a copy of the image data to use for checking against changes during the import process
                    originalImage: image,
                });
            })
        ,
        thumbnailHttpPath: proofImagesJpgs[i],
    }));
};
